import { inject, Pipe, PipeTransform } from '@angular/core';
import { GameThemeService } from '../service/game-theme.service';

@Pipe({
  name: 'achievementIcon',
})
export class AchievementIconPipe implements PipeTransform {
  protected readonly gameThemeService = inject(GameThemeService);

  transform(level: number, currentLevel: number, isDialog: boolean, allCompletedLevels: boolean): string {
    const achievement = this.gameThemeService.getCurrentAchievements().find(a => a.level === level);
    const iconPath = this.gameThemeService.getIconUrl();
    const earned = isDialog ? currentLevel >= level : currentLevel > level
    const iconName = earned || allCompletedLevels ? achievement?.icon_earned : achievement?.icon_default;

    return `${iconPath}${iconName}.svg`
  }

}
